import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneCheckboxSelectedValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const filterCriteria = control as FormArray;

    if (!filterCriteria || filterCriteria.length === 0) {
      return { noFilterCriteria: true };
    }

    const hasAtLeastOneNonEmptyValue = filterCriteria.controls.some((group: AbstractControl) => {
      if (group instanceof FormGroup) {
        const value = Object.values(group.value)[0] as boolean;

        return value;
      }
      return false;
    });

    return hasAtLeastOneNonEmptyValue ? null : { noFilterValues: true };
  };
}
